import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { WorkflowBaseModel } from '@smarttask-common/src/lib/models/Workflow/core/WorkflowBaseModel';

export enum WorkflowActionTypes {
    ADD_WORKFLOW = '[Workflow] Add Workflow',
    ADD_WORKFLOWS = '[Workflow] Add Workflows',
    UPSERT_WORKFLOW = '[Workflow] Upsert Workflow',
    UPSERT_WORKFLOWS = '[Workflow] Upsert Workflows',
    UPDATE_WORKFLOW = '[Workflow] Update Workflow',
    UPDATE_WORKFLOWS = '[Workflow] Update Workflows',
    DELETE_WORKFLOW = '[Workflow] Delete Workflow',
    DELETE_WORKFLOWS = '[Workflow] Delete Workflows',
    DELETE_ALL = '[Workflow] Delete All',

    UPDATE_SELECTED_ID = '[Workflow] Update SelectedId',
}

export class UpdateSelectedWorkflowId implements Action {
    readonly type = WorkflowActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_workflow_id: string) {}
}

export class AddOne implements Action {
    readonly type = WorkflowActionTypes.ADD_WORKFLOW;
    constructor(public workflow: WorkflowBaseModel) {}
}

export class AddMany implements Action {
    readonly type = WorkflowActionTypes.ADD_WORKFLOWS;
    constructor(public workflows: Array<WorkflowBaseModel>) {}
}

export class UpsertOne implements Action {
    readonly type = WorkflowActionTypes.UPSERT_WORKFLOW;
    constructor(public workflow: WorkflowBaseModel) {}
}

export class UpsertMany implements Action {
    readonly type = WorkflowActionTypes.UPSERT_WORKFLOWS;
    constructor(public workflows: Array<WorkflowBaseModel>) {}
}

export class UpdateOne implements Action {
    readonly type = WorkflowActionTypes.UPDATE_WORKFLOW;
    constructor(public workflow: Update<WorkflowBaseModel>) {}
}

export class UpdateMany implements Action {
    readonly type = WorkflowActionTypes.UPDATE_WORKFLOWS;
    constructor(public workflows: Array<Update<WorkflowBaseModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = WorkflowActionTypes.DELETE_WORKFLOW;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = WorkflowActionTypes.DELETE_WORKFLOWS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = WorkflowActionTypes.DELETE_ALL;
    constructor() {}
}

export type WorkflowActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedWorkflowId;
